import { useQuery } from "@tanstack/react-query";
import type { PolicyTemplateView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UsePolicyTemplatesQueryParams = {
  storeSlug: string;
};

export function usePolicyTemplatesQuery({ storeSlug }: UsePolicyTemplatesQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.seller.policyTemplates(storeSlug),
    queryFn: () =>
      apiJsonClient<PolicyTemplateView[]>(endpoints.seller.storePolicyTemplates, {
        cache: "no-store",
      }),
    enabled: storeSlug.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
}
